/* eslint-disable max-lines-per-function */
import useCreateNewsCritics from "hooks/useCreateNewsCritics";
import useNewsCritics from "hooks/useNewsCritics";
import usePreviewsNewsCritics from "hooks/usePreviewsNewsCritics";
import { useCallback, useEffect } from "react";
const useAddEditNews = () => {
    const { resetImages } = usePreviewsNewsCritics();
    const { clearAll, setReleaseDate, setSelectedIsNewsCriticsCreated, setSelectedSingleSource, state: { news } } = useNewsCritics();
    const { avNirvanaData, bluRayData, hidefDigestData, resetNewsSources, singleSourceData, whySoBluData } = useCreateNewsCritics();
    /**
     * AV Nirvana
     */
    useEffect(() => {
        if (avNirvanaData?.addNewsSource &&
            !news.sourcesIds?.includes(avNirvanaData.addNewsSource.id)) {
            const { addNewsSource: { id, serviceName } } = avNirvanaData;
            setSelectedIsNewsCriticsCreated(id, serviceName);
        }
    }, [avNirvanaData, news, setSelectedIsNewsCriticsCreated]);
    /**
     * Blu-ray.com
     */
    useEffect(() => {
        if (bluRayData?.addNewsSource &&
            !news.sourcesIds?.includes(bluRayData.addNewsSource.id)) {
            const { addNewsSource: { id, serviceName } } = bluRayData;
            setSelectedIsNewsCriticsCreated(id, serviceName);
        }
    }, [bluRayData, news, setSelectedIsNewsCriticsCreated]);
    /**
     * Hi-Def Digest
     */
    useEffect(() => {
        if (hidefDigestData?.addNewsSource &&
            !news.sourcesIds?.includes(hidefDigestData.addNewsSource.id)) {
            const { addNewsSource: { id, serviceName } } = hidefDigestData;
            setSelectedIsNewsCriticsCreated(id, serviceName);
        }
    }, [hidefDigestData, news, setSelectedIsNewsCriticsCreated]);
    /**
     * Single Source
     */
    useEffect(() => {
        if (singleSourceData?.addNewsSource &&
            !news.sourcesIds?.includes(singleSourceData.addNewsSource.id)) {
            const { addNewsSource: { id } } = singleSourceData;
            const releaseDate = singleSourceData.addNewsSource
                ?.releaseDate ?? undefined;
            setSelectedIsNewsCriticsCreated(id);
            setSelectedSingleSource({ id });
            if (releaseDate && !news.releaseDate) {
                setReleaseDate(releaseDate);
            }
        }
    }, [
        singleSourceData,
        news,
        setReleaseDate,
        setSelectedIsNewsCriticsCreated,
        setSelectedSingleSource
    ]);
    /**
     * Why So Blu?
     */
    useEffect(() => {
        if (whySoBluData?.addNewsSource &&
            !news.sourcesIds?.includes(whySoBluData.addNewsSource.id)) {
            const { addNewsSource: { id, serviceName } } = whySoBluData;
            setSelectedIsNewsCriticsCreated(id, serviceName);
        }
    }, [whySoBluData, news, setSelectedIsNewsCriticsCreated]);
    /**
     * onClearAll
     *
     * @description
     * Clears all news sources, images, and reviews.
     * Resets the state to its initial values.
     * @returns {void}
     *
     */
    const onClearAll = useCallback(() => {
        // Reset all news sources
        resetNewsSources();
        // Reset all images
        resetImages();
        // Clear all reviews
        clearAll();
    }, [clearAll, resetImages, resetNewsSources]);
    return {
        onClearAll
    };
};
export default useAddEditNews;
